import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { CustomRadio, Textarea } from 'components';
import styles from './CheckBoxModal.module.scss';

const CheckBoxModal = ({
    show,
    onHide,
    submitLabel,
    textAreaValue,
    title,
    placeholder,
    textAreaTitle,
    onChangeTextArea,
    onSubmit,
}: IProps) => {
    const [passed, setPassed] = React.useState(true);

    const submit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await onSubmit(passed);
    };

    return (
        <Modal
          show={show}
          onHide={onHide}
          centered
          dialogClassName={styles.checkBoxModal}
        >
            <Modal.Header
              closeButton
              className={styles.checkBoxModal__header}
            >
                <Modal.Title className={styles.checkBoxModal__title}>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={submit}>
                <Modal.Body className={styles.checkBoxModal__body}>
                    <Form.Text className="mb-5">
                        Укажите результат сдачи практической части экзамена:
                    </Form.Text>
                    <CustomRadio
                      label="Практическая часть успешно сдана"
                      name="exam-filter"
                      option="all"
                      checked={passed}
                      onClick={() => setPassed(true)}
                      className={styles.checkBoxModal_green}
                    />
                    <CustomRadio
                      label="Практическая часть не сдана"
                      name="exam-filter"
                      option="processedByNark"
                      checked={!passed}
                      onClick={() => setPassed(false)}
                      className={styles.checkBoxModal_red}
                    />
                    {!passed && (
                        <>
                            {textAreaTitle && (
                                <Form.Text className="mt-5 mb-4">
                                    {textAreaTitle}
                                </Form.Text>
                            )}
                            <Form.Group controlId="CheckBoxModalTextarea">
                                <Textarea
                                  name="CheckBoxModalTextarea"
                                  placeholder={placeholder}
                                  value={textAreaValue}
                                  onChange={value => onChangeTextArea(value)}
                                  rows={7}
                                  required
                                />
                            </Form.Group>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className={styles.checkBoxModal__footer}>
                    <Button type="submit" className="pl-4 pr-4">{submitLabel || 'Отклонить'}</Button>
                    <Button onClick={onHide} variant="outline-secondary">Отмена</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

interface IProps {
    textAreaValue: string;
    onHide: () => void;
    onChangeTextArea: (value: string) => void;
    onSubmit: (passed: boolean) => void;
    title: string;
    show: boolean;
    textAreaTitle?: string;
    submitLabel?: string;
    placeholder?: string;
}

export default CheckBoxModal;
